module.exports = __webpack_public_path__ + "static/WEDDING E&M-331-c9bfa14179343b1943fb0eda74446429.jpg";